import { z } from "zod";

/**
 * Schema for editing company details.
 *
 * Note: Most company fields are synced from Salesforce and are read-only.
 * Only fieldServiceSoftwareId can be edited through the Hub UI.
 */
export const editCompanySchema = z.object({
  // Company details
  companyName: z.string().min(1, "Company name is required"),
  companyEmail: z.string().email("Invalid email address").nullable().optional().or(z.literal("")),
  websiteUrl: z.string().nullable().optional().or(z.literal("")),
  salesforceId: z.string().nullable().optional().or(z.literal("")),
  intacctId: z.string().nullable().optional().or(z.literal("")),
  zoomAccountId: z.string().nullable().optional().or(z.literal("")),
  fathomAccountId: z.string().nullable().optional().or(z.literal("")),
  marketingEnabled: z.boolean(),
  hasEaglesAccess: z.boolean(),
  hasLATAAccess: z.boolean(),
  // Software
  fieldServiceSoftwareId: z.number().nullable().optional(),
});

// Schema for syncing company from Salesforce
export const syncCompanyFromSalesforceSchema = z.object({
  intacctId: z.string().min(1, "Intacct ID is required"),
});

// Type inference
export type EditCompanyFormData = z.infer<typeof editCompanySchema>;
export type SyncCompanyFromSalesforceFormData = z.infer<
  typeof syncCompanyFromSalesforceSchema
>;
